import { cn } from '@/lib/utils'

export const Logo = ({ className }: { className?: string }) => (
  <div
    aria-label="langmail"
    className={cn('inline-block whitespace-nowrap font-semibold text-2xl text-foreground tracking-[-0.2px]', className)}
    role="img"
  >
    langma<span aria-hidden="true">ı</span>
    <span
      aria-hidden="true"
      className="mr-[0.035em] -ml-[0.235em] inline-block h-[0.2em] w-[0.2em] rounded-full bg-primary align-[0.6em]"
    />
    l
  </div>
)
